import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/attributes/class/class.js";

//https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/

export default obj => {
	obj.each(function () {
		const cls = this.classList[0],
			observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					$(entry.target).toggleClass(cls + "--float", entry.intersectionRatio < 1);
				});
			}, {threshold: 1});
		observer.observe(this);
	});
};